<div 
    class="mouse-info-container"
    [style.left.px]="position.x"
    [style.top.px]="position.y"
    *ngIf="textParts.length > 0 && showing">
    <div class="info-part" *ngFor="let info of textParts; let i = index"
    [ngClass]="{'borderless': i == textParts.length - 1}">
        {{ info }}
    </div>
</div>